import { createContext } from "react";

export interface LandlordVerificationContextValue {
  /**
   * Opens the self verification modal (the current user uploads their own
   * identity document). No-op when the landlord is already verified.
   */
  openVerification: () => void;
  /**
   * Opens the property-driven verification modal, which lists every owner of
   * the given property still missing a confirmed identity document and lets the
   * acting landlord upload for each.
   */
  openPropertyVerification: (propertyId: string) => void;
}

/**
 * Handle for the landlord verification modal. Kept in its own component-free
 * module so the context object stays stable across HMR updates to the
 * verification-modal subtree — otherwise re-running `createContext` would
 * desync the provider from already-mounted consumers. The provider lives in
 * `LandlordVerificationProvider`.
 */
export const LandlordVerificationContext =
  createContext<LandlordVerificationContextValue | null>(null);
